import {
  DEFAULT_LOCALE,
  isLocaleSupported,
  type SupportedLocale,
} from './locale-constants';

/**
 * Resolves the browser's preferred locale to a SupportedLocale.
 * Exact-match only against SUPPORTED_LOCALES; unsupported values fall
 * back to DEFAULT_LOCALE. Used pre-login when user/org preferences are
 * unknown.
 */
export const getBrowserLocale = (): SupportedLocale => {
  if (typeof navigator === 'undefined') {
    return DEFAULT_LOCALE;
  }
  const language = navigator.language;
  if (!language) {
    return DEFAULT_LOCALE;
  }
  return isLocaleSupported(language) ? language : DEFAULT_LOCALE;
};
